import { Injectable } from "@angular/core";
import { from, map, Observable, of } from "rxjs";
import { RadioModel } from "../../../../shared/model/radio.model";
import { CarontePixTokenService } from "../../caronte-pix/caronte-pix.service";
import { HandlerService } from "../../comunicator-native/handler/handler";
import { DomainConvertionItem } from "../domain-data-caronte-broker.service";
import { DomainBrokerType } from "../model/domain-broker-type.model";
import { DomainDataType } from "../model/domain-data-type";
import { environment } from "../../../../../environments/environment";
import { responseDomainMock } from "../../../../../../src/app/shared/mocks/response-domain.mock";
import { responseCountryMock } from "../../../../../../src/app/shared/mocks/response-country.mock";

@Injectable({
  providedIn: "root",
})
export class ContaIonService {
  readonly COUNTRY_REL = "aberturaconta-paises";
  readonly USER_DOMAIN_REL = "aberturaconta-qa-dominios-ids";
  readonly USER_DOMAIN_PARAM_NAME = "id_dominio";
  readonly ROOT_DOMAIN_REL = "aberturaconta-consulta-dominios-cadastro";
  readonly ROOT_DOMAIN_PARAM_NAME = "nomeDominio";
  readonly ROOT_DOMAIN_PARAM_FILTRO = "filtro";
  private readonly domainTypes = [
    new DomainConvertionItem(
      DomainDataType.DocumentType,
      new DomainBrokerType("tipos_documento", 1)
    ),
    new DomainConvertionItem(
      DomainDataType.City,
      new DomainBrokerType("cidades", 1)
    ),
    new DomainConvertionItem(
      DomainDataType.Country,
      new DomainBrokerType("paises", 1)
    ),
    new DomainConvertionItem(
      DomainDataType.Gender,
      new DomainBrokerType("generos", 1)
    ),
    new DomainConvertionItem(
      DomainDataType.DocumentIssuing,
      new DomainBrokerType("emissores", 1)
    ),
    new DomainConvertionItem(
      DomainDataType.MaritalStatus,
      new DomainBrokerType("estados_civis", 1)
    ),
    new DomainConvertionItem(
      DomainDataType.OriginIncome,
      new DomainBrokerType("origens_renda", 1)
    ),
    new DomainConvertionItem(
      DomainDataType.Profession,
      new DomainBrokerType("profissoes", 1)
    ),
    new DomainConvertionItem(
      DomainDataType.State,
      new DomainBrokerType("estados", 1)
    ),
    new DomainConvertionItem(
      DomainDataType.Nationality,
      new DomainBrokerType("nacionalidades", 1)
    ),
    new DomainConvertionItem(
      DomainDataType.CountryNif,
      new DomainBrokerType("validacoes_nif_paises", "1")
    ),
  ];

  private readonly dominios = {
		[DomainDataType.DocumentType]: { id_dominio: '19' }, 
		[DomainDataType.Gender]: { id_dominio: '29' },
		[DomainDataType.DocumentIssuing]: { id_dominio: '13' },
		[DomainDataType.MaritalStatus]: { id_dominio: '23' },
		[DomainDataType.OriginIncome]: { id_dominio: '469' },
		[DomainDataType.Profession]: { id_dominio: '28' },
		[DomainDataType.Nationality]: { id_dominio: '24' }
	}; // dominioIds: "19,29,13,23,469,28,24"

  constructor(
    private caronte: CarontePixTokenService,
    private handlerService: HandlerService
  ) {}


  getQADomain(domainDataType: DomainDataType | DomainDataType[]): Observable<RadioModel[]> {
    let param: { ids: string };
  
    if (Array.isArray(domainDataType)) {
      const ids = domainDataType
        .map(type => this.dominios[type]?.id_dominio)
        .filter(Boolean)
        .join(','); 
      param = { ids: ids };
    } else {
      param = { ids: this.dominios[domainDataType]?.id_dominio };
    }
    if(environment.ambiente === "LOCAL"){
      return of(responseDomainMock.data.flatMap(group => group.itens.map(item => toQADomainModel(item, group.dominioId))));
    }
    return from(
      this.handlerService
      .caronteCommunicator(this.USER_DOMAIN_REL, null, null, false, param)
    ).pipe(
      map((response: any) => {  
        if (response?.data && Array.isArray(response.data)) {
          return response.data.flatMap(group =>
            group.itens.map(item => toQADomainModel(item, group.dominioId))
          );
        }
  
        return [];
      })
    );
  }
  
  

  getCountry(): Observable<RadioModel[]> {
    if(environment.ambiente === "LOCAL"){
       return of(responseCountryMock.data.map(toCountryDomainModel));
    }
    return from(
      this.handlerService
        .caronteCommunicator(this.COUNTRY_REL)
        .then((data: any) => {
          if (data?.errorData?.code || data?.errorData?.data?._links) {
            return Promise.resolve(data.errorData);
          } else if (data && data.data) {
            return data.data.map(toCountryDomainModel);
          } else {
            return [];
          }
        })
    );
  }

  getRootDomains(domainDataType: DomainDataType, parameter?: any): Observable<RadioModel[]> {
    const domainType = this.domainTypes.find((r) => r.domainDataType === domainDataType)?.domainType;
    const parameters = new Map()
      .set(this.ROOT_DOMAIN_PARAM_NAME, domainType.name)
      .set(this.ROOT_DOMAIN_PARAM_FILTRO, parameter);
  
    return from(
      this.handlerService.caronteCommunicator(this.ROOT_DOMAIN_REL, null, null, false, Object.fromEntries(parameters))
    ).pipe(
      map((data: any) => {
        console.log("Dados que chega do back domain-root")
        if (data && data.data) {
          switch (domainType.name) {
            case "tipos_documento":
              return data.data.map(toDomainOtherModel);
            case "emissores":
              return data.data.map(toDomainOtherModel);
            case "generos":
              return data.data.map(toDomainGenderModel);
            case "validacoes_nif_paises":
              return data.data.map(toDomainCountryNifModel);
            default:
              return data.data.map(toDomainModel);
          }
        } else {
          return [];
        }
      })
    );
  }
}

function toQADomainModel(item: any, dominioId: number): RadioModel {
  return new RadioModel(
    item.codigo,
    item.valorSumarizado,
    item.valorSumarizado,
    null,
    dominioId
  );
}


function toCountryDomainModel(item) {
  return new RadioModel(
    item.sigla_pais_dois_caracteres,
    item.nome_pais,
    item.nome_pais
  );
}

function toDomainModel(item) {
  return new RadioModel(item.codigo, item.valor, item.valor);
}

function toDomainOtherModel(item) {
  return new RadioModel(
    item.codigo,
    item.campos_adicionais[0].sigla,
    item.campos_adicionais[0].sigla
  );
}

function toDomainGenderModel(item) {
  return new RadioModel(
    item.codigo,
    item.campos_adicionais[0].descricao,
    item.campos_adicionais[0].descricao
  );
}

function toDomainCountryNifModel(item) {
  const additionalFields = [
    {
      validacoes_nif: {
        minimo_caracteres:
          item.camposAdicionais[0].validacoesNif.minimoCaracteres,
        preenchimento_obrigatorio:
          item.camposAdicionais[0].validacoesNif.preenchimentoObrigatorio,
        maximo_caracteres:
          item.camposAdicionais[0].validacoesNif.maximoCaracteres,
        tamanhos_permitidos:
          item.camposAdicionais[0].validacoesNif.tamanhosPermitidos,
        formato: item.camposAdicionais[0].validacoesNif.formato,
        caracteres_especiais_nao_permitidos:
          item.camposAdicionais[0].validacoesNif.caracteresEspeciaisNaoPermitidos,
      },
    },
  ];
  return new RadioModel(item.codigo, item.valor, item.valor, additionalFields);
}
